import { PACKAGE_ASPECT_RATIO } from "../const";
import { useCollectionItem } from "./hooks/use-collection-item";
import { useTrackingCollectionItem } from "./hooks/use-tracking-collection-item";
import * as Styled from "./style";
import { Carousel } from "~/components/blocks/common/carousel";
import { LeftTag } from "~/components/blocks/common/left-tag";
import type { G_GetVideoQuery } from "~/lib/graphql";

type CollectionItemProps = {
  collectionType: "videos" | "books";
  videoData: G_GetVideoQuery["video"];
};

/**
 * 関連作品を表示するコンポーネント
 * - アイテム画像をクリックしたら、DMM.TVドメイン外へ画面遷移させる
 * @param props {@link CollectionItemProps}
 */
export const CollectionItem = (props: CollectionItemProps) => {
  const { collectionType, videoData } = props;
  const { videos, books } = videoData.relatedItems;
  const { categories } = videoData;

  const { sectionRef, displayItemCount, relatedBooksItems, relatedVideoItems } = useCollectionItem({
    books,
    videos,
    categories,
  });

  useTrackingCollectionItem({ collectionType, videos, books });

  return (
    <>
      {collectionType === "videos" && videos.length > 0 && (
        <section ref={sectionRef}>
          <Styled.Heading size="M">関連ビデオ</Styled.Heading>

          <Carousel
            uniqueId="related-video-id"
            displayItemCount={displayItemCount}
            isDisabledPreviewModal
            items={relatedVideoItems.map((node) => {
              return {
                leftTag: (
                  <LeftTag isNewArrival={node.isNewArrival} isExclusive={node.isExclusive} customTag={node.customTag} />
                ),
                ...node,
              };
            })}
            skeletonSetting={{ isShowSkeleton: videos === undefined, aspectRatio: PACKAGE_ASPECT_RATIO }}
          />
        </section>
      )}

      {collectionType === "books" && books.length > 0 && (
        <section ref={sectionRef}>
          <Styled.Heading size="M">関連ブック</Styled.Heading>

          <Styled.BooksCarousel
            uniqueId="related-books-id"
            displayItemCount={displayItemCount}
            isDisabledPreviewModal
            items={relatedBooksItems}
            skeletonSetting={{ isShowSkeleton: books === undefined, aspectRatio: PACKAGE_ASPECT_RATIO }}
          />
        </section>
      )}
    </>
  );
};
